<template>
  <div class="modal-content">
    <form class="form-horizontal needs-validation" novalidate id="formAddReceiveDetail">
      <div class="modal-header">
        <h5 class="modal-title" id="ReceiveDetailModalLabel">Add Stock In Detail</h5>
        <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-6 mb-3">
            <label class="col-md-12">Dock</label>
            <div class="col-md-12">
              <select v-model="dk_id" class="form-select" @change="getPartStore()" style="width: 100%;">
                <option value="">-- Plase select dock</option>
                <option v-for="(d, i) in dockModalList" :key="'md' + i" :value="d.dk_id">
                  {{ d.dk_code }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm-6 mb-3">
            <label class="col-md-12">Supplier</label>
            <p>{{ modalDetailData.supplier }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 mb-3">
            <label class="col-md-12">Part Store</label>
            <div class="col-md-12">
              <select
                v-model="modalDetailData.ps_id"
                class="form-control-line form-select form-select-fix"
                style="width: 100%"
                required
                placeholder="Choose part store..."
              >
                <option selected value="">Choose part store</option>
                <option v-for="(ps, i) in partstoreModalList" :key="'ps' + i" :value="ps.ps_id">
                  {{ ps.pr_id_number }} | {{ ps.pr_number }} | {{ ps.pr_name }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-sm-6 mb-3">
            <label class="col-md-12">QTY</label>
            <div class="col-md-12">
              <input type="number" v-model="modalDetailData.recd_qty" class="form-control" placeholder="enter qty" required />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-fix" @click="closeModal"><i class="fa fa-times"></i> Close</button>
        <button type="button" class="btn btn-info btn-fix" @click="checkForm"><i class="fas fa-save"></i> Save</button>
      </div>
    </form>
  </div>
</template>

<script>
import api from '../../models/receive'

export default {
  props: ['modalDetailData', 'reloadDetailPagination'],
  data() {
    return {
      dockModalList: [],
      partstoreModalList: [],
      dk_id: ''
    }
  },
  methods: {
    checkForm() {
      var $myForm = $('#formAddReceiveDetail')
      if (!$myForm[0].checkValidity()) {
        $('#formAddReceiveDetail').addClass('was-validated')
      } else {
        this.addReceiveDetail()
      }
    },
    closeModal() {
      $('#ReceiveDetailModal').modal('hide')
    },
    addReceiveDetail() {
      $('#ReceiveDetailModal').modal('hide')
      let formData = {
        rec_id: this.modalDetailData.rec_id,
        ps_id: this.modalDetailData.ps_id,
        recd_qty: this.modalDetailData.recd_qty
      }

      api.addReceiveDetail(
        this.$store.state.URLHost,
        formData,
        this.header,
        result => {
          if (result.response === true) {
            this.reloadDetailPagination()
            this.alert_msg('success', 'Add Receive Detail', result.message)
          } else {
            this.reloadDetailPagination()
            this.alert_msg('warning', 'Add Receive Detail', result.message)
          }
        },
        error => {
          this.reloadDetailPagination()
          this.alert_msg('error', 'Add Receive Detail', error.message)
        }
      )
    },
    getDockStore() {
      this.dockModalList = []
      var obj = {
        spl_id: this.modalDetailData.spl_id
      }
      this.header.params = obj
      api.getDockStore(
        this.$store.state.URLHost,
        this.header,
        result => {
          if (result.response === true) {
            this.dockModalList = result.data
          } else {
            this.alert_msg('warning', 'An error occurred.', result.message)
          }
        },
        error => {
          this.alert_msg('error', 'An error occurred.', error.message)
        }
      )
    },
    getPartStore() {
      this.partstoreModalList = []
      var obj = {
        spl_id: this.modalDetailData.spl_id,
        dk_id: this.dk_id
      }
      this.header.params = obj
      api.getPartStore(
        this.$store.state.URLHost,
        this.header,
        result => {
          if (result.response === true) {
            this.partstoreModalList = result.data
          } else {
            this.alert_msg('warning', 'An error occurred.', result.message)
          }
        },
        error => {
          this.alert_msg('error', 'An error occurred.', error.message)
        }
      )
    }
  },
  watch: {
    'modalDetailData.spl_id': {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== 0) {
          this.getDockStore()
          this.getPartStore()
        }
      }
    }
  },
  mounted() {
    $('#ReceiveDetailModal').on('show.bs.modal', event => {
      if (event.target.id === 'ReceiveDetailModal') {
        $('#formAddReceiveDetail').removeClass('was-validated')
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/receive_detail_add_modal.vue